import React, { useEffect, useRef, useState } from "react";
import { Tabs, Tab } from "react-bootstrap";
import styles from "./AdharRegistrartion.module.scss";
import {
  getAbhaUserByAbhaNumber,
  verifyGetByAbhaNumber,
  getUserDetails,
} from "../../../../store/slices/abhaRegistrationSlice";
import { useDispatch, useSelector } from "react-redux";
import AbhaAddressVerification from "./AbhaAddressVerification";
import {
  MAX_OTP_RESEND_ATTEMPTS,
  getOtpResendAttemptMessage,
} from "./otpResendAttempts";

const AbhaVerification = ({
  clinicId,
  setModalVisible,
  setShowRegistrationModal,
  setAadharNumber,
  loading,
}) => {
  const dispatch = useDispatch();
  const { token } = useSelector((state) => state.auth);
  const [showAbhaNumField, setShowAbhaNumField] = useState(true);
  const [showOtpField, setShowOtpField] = useState(false);
  const [abhaPart1, setAbhaPart1] = useState("");
  const [abhaPart2, setAbhaPart2] = useState("");
  const [abhaPart3, setAbhaPart3] = useState("");
  const [abhaPart4, setAbhaPart4] = useState("");
  const [inputError, setInputError] = useState("");
  const [key, setKey] = useState("abhanumber");
  const [otp, setOtp] = useState(["", "", "", "", "", ""]);
  const [timer, setTimer] = useState(20);
  const inputRefs = useRef([]);
  const [otpError, setOtpError] = useState("");
  const [verificationMethod, setVerificationMethod] = useState("aadhaar");
  const [abhaNumber, setAbhaNumber] = useState("");
  const [scopeType, setScopeType] = useState("aadhaar-verify");
  const [otpSystem, setOtpSystem] = useState("aadhaar");
  const [adharOtpGenerateMsg, setAdharOtpGenerateMsg] = useState("");
  const OTP_RESEND_TIMEOUT = 60;
  const [resendCount, setResendCount] = useState(0);
  const [maxAttemptsReached, setMaxAttemptsReached] = useState(false);
  const [addressTabKey, setAddressTabKey] = useState(0);

  const ref1 = useRef();
  const ref2 = useRef();
  const ref3 = useRef();
  const ref4 = useRef();

  useEffect(() => {
    let interval;
    if (showOtpField && timer > 0) {
      interval = setInterval(() => {
        setTimer((prev) => prev - 1);
      }, 1000);
    }
    return () => clearInterval(interval);
  }, [showOtpField, timer]);

  const handleInputChange = (e, setter, maxLength, nextRef, prevRef) => {
    const value = e.target.value.replace(/\D/g, "");
    setter(value);
    if (inputError) setInputError("");
    if (value.length === maxLength && nextRef) {
      nextRef.current.focus();
    } else if (value.length === 0 && prevRef) {
      prevRef.current.focus();
    }
  };

  const handleOtpChange = (e, index) => {
    setOtpError("");
    const value = e.target.value.replace(/\D/g, "");
    if (value.length <= 1) {
      const newOtp = [...otp];
      newOtp[index] = value;
      setOtp(newOtp);
      if (value && index < 5) inputRefs.current[index + 1]?.focus();
    }
  };

  const handleKeyDown = (e, index) => {
    if (e.key === "Backspace" && !otp[index] && index > 0) {
      inputRefs.current[index - 1]?.focus();
    }
  };

  const formatTimer = (seconds) => {
    const m = Math.floor(seconds / 60);
    const s = seconds % 60;
    return `${m}:${s < 10 ? "0" : ""}${s}`;
  };

  const handleNextClick = async () => {
    setAadharNumber("");
    const fullAbhaNumber = `${abhaPart1}-${abhaPart2}-${abhaPart3}-${abhaPart4}`;
    setAbhaNumber(fullAbhaNumber);
    const digitsOnly = fullAbhaNumber.replace(/-/g, "");
    if (!/^\d{14}$/.test(digitsOnly)) {
      setInputError("Please enter a valid 14-digit ABHA number.");
      return;
    }
    try {
      const response = await dispatch(
        getAbhaUserByAbhaNumber({
          clinicId,
          loginId: fullAbhaNumber,
          scopeType,
          otpSystem,
          token,
        })
      ).unwrap();
      if (response?.success) {
        setAdharOtpGenerateMsg(response?.result?.list);
        setShowAbhaNumField(false);
        setShowOtpField(true);
        setTimer(OTP_RESEND_TIMEOUT);
        return;
      }
      setInputError("Invalid ABHA number. Please try again.");
    } catch (err) {
      setInputError("Something went wrong. Please try again.");
    }
  };

  const handleResendOtp = async () => {
    if (timer > 0 || resendCount >= MAX_OTP_RESEND_ATTEMPTS) return;
    try {
      setOtpError("");
      const response = await dispatch(
        getAbhaUserByAbhaNumber({
          clinicId,
          loginId: abhaNumber,
          scopeType,
          otpSystem,
          token,
        })
      ).unwrap();
      if (response?.success) {
        setOtp(["", "", "", "", "", ""]);
        setAdharOtpGenerateMsg(response?.result?.list);
        setTimer(OTP_RESEND_TIMEOUT);
        const nextCount = resendCount + 1;
        setResendCount(nextCount);
        if (nextCount >= MAX_OTP_RESEND_ATTEMPTS) {
          setMaxAttemptsReached(true);
        }
        return;
      }
      setOtpError("Failed to resend OTP. Please try again.");
    } catch (err) {
      console.error("Error during OTP resend:", err);
      setOtpError("Failed to resend OTP. Please try again.");
    }
  };

  const handleFinalNextClick = async () => {
    const enteredOtp = otp.join("");
    if (enteredOtp.length !== 6 || !enteredOtp) {
      setOtpError("Please enter a valid 6-digit OTP.");
      return;
    }
    setOtpError("");
    try {
      const response = await dispatch(
        verifyGetByAbhaNumber({ clinicId, otp: enteredOtp, scopeType, token })
      );
      if (
        response?.payload?.success === true &&
        response?.payload?.result?.list === "success"
      ) {
        const userDetailsResponse = await dispatch(
          getUserDetails({ clinicId: clinicId, token })
        );
        if (userDetailsResponse?.payload?.success) {
          setOtpError("");
          setShowRegistrationModal(false);
          setModalVisible(true);
        } else {
          setOtpError("Something went wrong. Please try again");
        }
      } else {
        setOtpError("Invalid OTP. Please try again.");
      }
    } catch (err) {
      setOtpError("something went wrong. Please try again.");
    }
  };

  const resetAllStates = () => {
    setShowAbhaNumField(true);
    setShowOtpField(false);
    setAbhaPart1("");
    setAbhaPart2("");
    setAbhaPart3("");
    setAbhaPart4("");
    setInputError("");
    setOtp(["", "", "", "", "", ""]);
    setTimer(20);
    setOtpError("");
    setVerificationMethod("aadhaar");
    setScopeType("aadhaar-verify");
    setOtpSystem("aadhaar");
    setAdharOtpGenerateMsg("");
    setResendCount(0);
    setMaxAttemptsReached(false);
  };
  const handleTabChange = (k) => {
    if (k === "abhanumber") {
      resetAllStates(); // Your existing reset for Tab 1
    }

    if (k === "profile") {
      // Forces re-render of Tab 2
      setAddressTabKey((prev) => prev + 1);
    }

    setKey(k);
  };

  return (
    <Tabs
      id="controlled-tab-example"
      activeKey={key}
      onSelect={handleTabChange}
      className={styles.navTabs}
    >
      <Tab eventKey="abhanumber" title="ABHA NUMBER">
        {showAbhaNumField && (
          <div
            className={`d-flex flex-wrap gap-3 align-items-end ${styles.consent}`}
          >
            <div className="form-group" style={{ width: "18%" }}>
              <label className="col-form-label">ABHA Number</label>
              <input
                type="text"
                className="form-control"
                value={abhaPart1}
                ref={ref1}
                onChange={(e) =>
                  handleInputChange(e, setAbhaPart1, 2, ref2, null)
                }
                maxLength={2}
                placeholder="00"
              />
            </div>

            {[abhaPart2, abhaPart3, abhaPart4].map((part, index) => {
              const setPart = [setAbhaPart2, setAbhaPart3, setAbhaPart4][index];
              const currentRef = [ref2, ref3, ref4][index];
              const nextRef = [ref3, ref4, null][index];
              const prevRef = [ref1, ref2, ref3][index];

              return (
                <div
                  key={index}
                  className="form-group"
                  style={{ width: "25%" }}
                >
                  <input
                    type="text"
                    className="form-control"
                    value={part}
                    ref={currentRef}
                    onChange={(e) =>
                      handleInputChange(e, setPart, 4, nextRef, prevRef)
                    }
                    maxLength={4}
                    placeholder="0000"
                  />
                </div>
              );
            })}

            {inputError && (
              <p className="text-danger small mt-2">{inputError}</p>
            )}

            <div className="w-100 mt-3">
              <label className="fw-bold mb-2 d-block">
                Verify With
                <span className="text-muted" style={{ fontSize: "0.8rem" }}>
                  (Select which method you want to verify with)
                </span>
              </label>

              <div className="d-flex gap-3">
                <div
                  className={`px-4 py-2 rounded border ${
                    verificationMethod === "aadhaar"
                      ? "bg-primary text-white border-primary"
                      : "bg-light text-dark"
                  }`}
                  style={{ cursor: "pointer" }}
                  onClick={() => {
                    setVerificationMethod("aadhaar");
                    setScopeType("aadhaar-verify");
                    setOtpSystem("aadhaar");
                  }}
                >
                  Aadhaar OTP
                </div>
                <div
                  className={`px-4 py-2 rounded border ${
                    verificationMethod === "abha"
                      ? "bg-primary text-white border-primary"
                      : "bg-light text-dark"
                  }`}
                  style={{ cursor: "pointer" }}
                  onClick={() => {
                    setVerificationMethod("abha");
                    setScopeType("mobile-verify");
                    setOtpSystem("abdm");
                  }}
                >
                  ABHA OTP
                </div>
              </div>
            </div>

            <div className="text-end w-100">
              <button
                className="btn btn-primary"
                onClick={handleNextClick}
                disabled={loading}
              >
                {loading ? "Processing..." : "Next"}
              </button>
            </div>
          </div>
        )}

        {showOtpField && (
          <div className={styles.adhaarDiv}>
            <p>Confirm OTP</p>
            <label className="col-form-label">{adharOtpGenerateMsg}</label>
            <div className="d-flex gap-2 mt-2">
              {otp.map((digit, index) => (
                <input
                  key={index}
                  type="text"
                  className="form-control text-center"
                  value={digit}
                  onChange={(e) => handleOtpChange(e, index)}
                  onKeyDown={(e) => handleKeyDown(e, index)}
                  maxLength={1}
                  ref={(el) => (inputRefs.current[index] = el)}
                  style={{ width: "4rem" }}
                />
              ))}
            </div>

            {otpError && <p className="text-danger small mt-2">{otpError}</p>}
            {resendCount > 0 && (
              <p
                className={`small mt-2 mb-0 ${
                  resendCount >= MAX_OTP_RESEND_ATTEMPTS
                    ? "text-danger"
                    : "text-success"
                }`}
              >
                {getOtpResendAttemptMessage(resendCount)}
              </p>
            )}

            <div className="mt-2">
              {!maxAttemptsReached ? (
                <>
                  <small className="fs-13">Didn't receive the OTP?</small>{" "}
                  <small
                    onClick={handleResendOtp}
                    style={{
                      cursor: timer > 0 ? "not-allowed" : "pointer",
                      color: timer > 0 ? "gray" : "blue",
                      marginLeft: "0.5rem",
                    }}
                  >
                    Resend OTP
                  </small>
                  <span className="ms-3">Time left: {formatTimer(timer)}</span>
                </>
              ) : (
                <div className="text-black fs-13">
                  Resend OTP limit reached. Please try again later.
                </div>
              )}
            </div>

            <div className="text-end mt-3">
              <button
                className="btn btn-success"
                onClick={handleFinalNextClick}
                disabled={loading}
              >
                {loading ? (
                  <>
                    <span
                      className="spinner-border spinner-border-sm me-2"
                      role="status"
                      aria-hidden="true"
                    ></span>
                    Verifying...
                  </>
                ) : (
                  "Verify OTP"
                )}
              </button>
            </div>
          </div>
        )}
      </Tab>

      <Tab eventKey="profile" title="ABHA ADDRESS" key={addressTabKey}>
        <AbhaAddressVerification
          key={addressTabKey} // 👈 Important
          setAadharNumber={setAadharNumber}
          clinicId={clinicId}
          setModalVisible={setModalVisible}
          setShowRegistrationModal={setShowRegistrationModal}
          loading={loading}
        />
      </Tab>
    </Tabs>
  );
};

export default AbhaVerification;
